import { ESIM_HUBBY_PROVIDER, ESIM_HUBBY_UPSELL_OFFER_ID } from 'loyalty/constants/loyaltyEsimConstants'

type OrderExperienceItemLike = Pick<App.OrderExperienceItem, 'provider' | 'experienceId'>

export default function isOrderEsimUpsellExperienceItem(item: OrderExperienceItemLike): boolean {
  return item.provider === ESIM_HUBBY_PROVIDER && item.experienceId === ESIM_HUBBY_UPSELL_OFFER_ID
}
